var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-content",on:{"click":_vm.handleClick}},[_c('Head',{ref:"head",attrs:{"backFn":_vm.back}}),_c('div',{class:[_vm.isMaxScreen ? 'pc_privacy-policy-container' : 'privacy-policy-container']},[_c('div',{staticClass:"page-text-container",domProps:{"innerHTML":_vm._s(_vm.workData)}})]),_c('bottom',{ref:"bottom"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }